import { Center, VStack, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import EmptyFolderGraphic from '../../../../graphics/media-library/EmptyFolderGraphic'
import { useTranslation } from 'react-i18next'

const NoResultsFoundView = ({minHeight}: {minHeight?: string}): ReactElement => {
  const { t } = useTranslation()
  return (
    <Center height="100%" width="100%" minHeight={minHeight}>
      <VStack spacing={6}>
        <Icon
          as={EmptyFolderGraphic}
          width="260px"
          height="200px"
          color="appClearBlue"
        />

        <Heading as="h4" fontSize="md" color="appBattleshipGrey">
          {t('no_results_found', 'No results found')}
        </Heading>
      </VStack>
    </Center>
  )
}

export default NoResultsFoundView

